export const ROOT_CATALOG_ID = -1;
export const ROOT_CATALOG_ICON_NAME = 'dots';
export const WEB_CATALOG_ROOT_ALL_CODE = '_ALL';
export const ABOUT_TAB_ID = 'about-tab-id';
export const OUR_PLATFORM_ID = 'our-platform-id';
export const NAVIGATION_COOKIES_URL = '#';
export const CATALOG_SHRINK_THRESHOLD = 8;
export let CatalogPhotoThumbnail;

(function (CatalogPhotoThumbnail) {
  CatalogPhotoThumbnail["Thumb24"] = "thumb24";
  CatalogPhotoThumbnail["Thumb48"] = "thumb48";
  CatalogPhotoThumbnail["Thumb70"] = "thumb70";
  CatalogPhotoThumbnail["Thumb150"] = "thumb150";
})(CatalogPhotoThumbnail || (CatalogPhotoThumbnail = {}));

export let CatalogAttribute;

(function (CatalogAttribute) {
  CatalogAttribute[CatalogAttribute["Navigation"] = 1] = "Navigation";
  CatalogAttribute[CatalogAttribute["Breadcrumb"] = 2] = "Breadcrumb";
  CatalogAttribute[CatalogAttribute["Filter"] = 3] = "Filter";
  CatalogAttribute[CatalogAttribute["Subcatalog"] = 4] = "Subcatalog";
  CatalogAttribute[CatalogAttribute["Home"] = 5] = "Home";
  CatalogAttribute[CatalogAttribute["StyleFilter"] = 6] = "StyleFilter";
})(CatalogAttribute || (CatalogAttribute = {}));

export let CatalogFrom;

(function (CatalogFrom) {
  CatalogFrom[CatalogFrom["RecentPurchases"] = 0] = "RecentPurchases";
})(CatalogFrom || (CatalogFrom = {}));

export const STYLE_DEPTH = 2;
export let CategoryIntentType;

(function (CategoryIntentType) {
  CategoryIntentType["Men"] = "men_fashion";
  CategoryIntentType["Women"] = "women_fashion";
  CategoryIntentType["NoPreference"] = "no_preference";
})(CategoryIntentType || (CategoryIntentType = {}));

export let CatalogCode;

(function (CatalogCode) {
  CatalogCode["WomenRoot"] = "WOMEN_ROOT";
  CatalogCode["Mens"] = "MENS";
  CatalogCode["ChildrenNew"] = "CHILDREN_NEW";
  CatalogCode["PetCare"] = "PET_CARE";
  CatalogCode["Home"] = "HOME";
  CatalogCode["Entertainment"] = "ENTERTAINMENT";
})(CatalogCode || (CatalogCode = {}));